import { render, staticRenderFns } from "./ElButtonIcon.vue?vue&type=template&id=8c3f0a0c&scoped=true&"
import script from "./ElButtonIcon.vue?vue&type=script&lang=js&"
export * from "./ElButtonIcon.vue?vue&type=script&lang=js&"
import style0 from "./ElButtonIcon.vue?vue&type=style&index=0&id=8c3f0a0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3f0a0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
